import React, { useContext, useMemo } from 'react';
import Breadcrumbs from 'ati-ui-react/components/Breadcrumbs';

import { ConfigContext } from 'contexts';
import { useLocalized } from 'utils/useLocalized';
import styles from '../../styles.modules.scss';
import i18nStrings from './strings';

const BreadcrumbsLinks = () => {
    const strings = useLocalized(i18nStrings);
    const { mainSiteUrl } = useContext(ConfigContext);

    const breadCrumbLinks = useMemo(() => {
        return [
            {
                href: mainSiteUrl,
                name: strings.mainPage
            },
            {
                name: strings.appTitle,
            },
        ];
    }, [mainSiteUrl, strings]);

    return (
        <div className={styles['breadcrumbs']}>
            <Breadcrumbs links={breadCrumbLinks} />
        </div>
    );

};

export default BreadcrumbsLinks;
